import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import GlobalErrorBoundary from "@/components/GlobalErrorBoundary";
import { captureFirstTouchAttribution } from "@/lib/attribution";
import { initFirstPartyAnalytics } from "@/lib/firstPartyAnalytics";
import { initVkPixel } from "@/lib/vkPixel";

const APP_VERSION = "2026-08-10-registration-contract-fix-2";

const clearLegacyBrowserCache = async () => {
  try {
    const storedVersion = localStorage.getItem("speeddate_app_version");
    if (storedVersion === APP_VERSION) {
      return;
    }

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }

    localStorage.setItem("speeddate_app_version", APP_VERSION);
  } catch (error) {
    console.warn("Cache cleanup skipped:", error);
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

captureFirstTouchAttribution();
initFirstPartyAnalytics();
initVkPixel();
clearLegacyBrowserCache();
